module.exports = __webpack_public_path__ + "dc0a825c3a630b34c079597ddfce2033.png";